<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('subject')"
      prop="subject"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.subject"
        @input="form.subject = valueTrimLeft($event)"
        @change="updateModelItem('subject', { required: true })"
      />
    </el-form-item>
    <el-form-item
      :label="L10n('table-index')"
      prop="tableIndex"
      :rules="getValidationRule('required,number')"
      class="material-style">
      <el-input
        :value="form.tableIndex"
        @input="form.tableIndex = valueInteger($event)"
        @change="updateModelItem('tableIndex', { required: true })"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormCompanyRemarkSubjectS',
  mixins: [Form]
}
</script>
